import React from 'react'
import PropTypes from 'prop-types'
import Component from 'decorators/Component'

class ExternalContent extends React.PureComponent {
  static propTypes = {
    previewMode: PropTypes.bool.isRequired
  }

  componentDidMount () {
    if (this.props.previewMode) {
      this._container && this._container.addEventListener('click', this.onHrefClickInPreviewMode)
    }
  }

  onHrefClickInPreviewMode = (e) => {
    // TODO: this does not work since target element could be a child element nested inside <a>
    if (e.target.tagName.toLowerCase() === 'a') {
      const { t } = this.props
      e.preventDefault()
      window.confirm(t('This link cannot be opened in customisation preview. It will be opened in a new window (_target_).\nClick OK to continue', { target: e.target.href })) && window.open(e.target.href, '_blank')
    }
  }

  render () {
    return (
      <div ref={(e) => { this._container = e }}>
        {this.props.children}
      </div>
    )
  }
}

export default Component()(ExternalContent)
